'use strict'

import * as types from '@/store/types.js'
import GuiHelper from '@/utils/gui-helper'

const state = {
    error: {
        show: false,
        message: null,
        showMainPage: false
    },
    warning: {
        show: false,
        message: null
    },
    loading: false,
    tryInit: false,
    loadingId: null,
    quantityItemList: GuiHelper.getQuantityItemList()
}

const mutations = {
    [types.GUI.loading.set]: (store, value) => {
        store.loading = value
    },
    [types.GUI.error.set]: (store, value) => {
        store.error = value
    },
    [types.GUI.warning.set]: (store, value) => {
        store.warning = value
    },
    [types.GUI.loadingId.set]: (store, value) => {
        store.loadingId = value
    },
    [types.GUI.loadingId.reset]: (store) => {
        store.loadingId = null
    },
    [types.GUI.tryInit.set]: (store) => {
        store.tryInit = true
    },
    [types.GUI.layout.set]: (store, value) => {
        store.settings.layout = value
    },
    [types.GUI.colorSchema.set]: (store, value) => {
        store.settings.colorSchema = value
    }
}

const actions = {
    [types.GUI.loading.set](context, value) {
        context.commit(types.GUI.loading.set, value)
    },
    [types.GUI.error.set](context, value) {
        context.commit(types.GUI.error.set, value)
    },
    [types.GUI.warning.set](context, value) {
        context.commit(types.GUI.warning.set, value)
    },
    [types.GUI.loadingId.set](context, value) {
        context.commit(types.GUI.loadingId.set, value)
    },
    [types.GUI.loadingId.reset](context) {
        context.commit(types.GUI.loadingId.reset)
    },
    [types.GUI.tryInit.set](context) {
        context.commit(types.GUI.tryInit.set)
    },
    [types.GUI.layout.set](context, value) {
        context.commit(types.GUI.layout.set, value)
    },
    [types.GUI.colorSchema.set](context, value) {
        context.commit(types.GUI.colorSchema.set, value)
    }
}

const getters = {
    [types.GUI.warning.get](state) {
       return state.warning
    }
}
export default {
    state,
    mutations,
    actions,
    getters
}
